import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

let resetTimerRef = null;

export default function useAutoLogout() {
  const router = useRouter();
  const store = useStore();
  const userRole = store.getters.userInfo?.user?.permission;
  // Only apply auto logout for students
  if (userRole !== "student") {
     console.log("Auto logout not applied: user is not a student.");
    return;
  }
  let timer = null;

  const INACTIVITY_TIME = Number(process.env.VUE_APP_AUTO_LOGOUT_TIME);

  if (!INACTIVITY_TIME) {
    console.error("VUE_APP_AUTO_LOGOUT_TIME is missing");
    return;
  }

  const logout = async () => {
    console.warn("Auto logout triggered");

    clearTimeout(timer);

    await store.dispatch("logOutUser");

    router.replace({ name: "Login" });
  };

  const resetTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(logout, INACTIVITY_TIME);
  };

  resetTimerRef = resetTimer;

  const events = [
    "mousemove",
    "mousedown",
    "click",
    "keydown",
    "scroll",
    "touchstart",
  ];

  onMounted(() => {
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();
  });

  onUnmounted(() => {
    events.forEach((e) => window.removeEventListener(e, resetTimer));
    clearTimeout(timer);
  });
}

export function videoActivity() {
  if (resetTimerRef) {
    resetTimerRef();
  }
}
